<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list category-tree">
            <li @click="swatchCategory({ categoryId: '', categoryName: '全部' })"
              :class="{ 'selected': productManageInfo.conditions.categoryId === '' }">
              {{ $t('common.all') }}
            </li>
            <li v-if="categoryTree.length" class="category-tree-actions">
              <span @click="expandAllCategories">展开全部</span>
              <span @click="collapseAllCategories">折叠全部</span>
            </li>
            <li v-for="parent in categoryTree" :key="parent.categoryId" class="category-tree-group">
              <div
                class="category-tree-parent-row"
                :class="{ 'selected': productManageInfo.conditions.categoryId == parent.categoryId }"
              >
                <span
                  v-if="parent.children && parent.children.length"
                  class="category-tree-toggle"
                  @click.stop="toggleCategoryExpand(parent.categoryId)"
                >
                  <i :class="isCategoryExpanded(parent.categoryId) ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
                </span>
                <span v-else class="category-tree-toggle category-tree-toggle-placeholder"></span>
                <div
                  class="category-tree-item category-tree-parent"
                  @click="swatchCategory(parent)"
                >
                  {{ parent.categoryName }}
                </div>
              </div>
              <ul
                v-if="parent.children && parent.children.length && isCategoryExpanded(parent.categoryId)"
                class="category-tree-children"
              >
                <li
                  v-for="child in parent.children"
                  :key="child.categoryId"
                  class="category-tree-item"
                  @click="swatchCategory(child)"
                  :class="{ 'selected': productManageInfo.conditions.categoryId == child.categoryId }"
                >
                  {{ child.categoryName }}
                </li>
              </ul>
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="21">
        <el-card>
          <div slot="header" class="clearfix flex justify-between">
            <span>查询条件</span>
          </div>
          <el-form :inline="true" class="demo-form-inline text-left">
            <el-form-item>
              <el-input
                placeholder="请输入商品名称"
                v-model="productManageInfo.conditions.prodName"
                clearable
              />
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="productManageInfo.conditions.state"
                placeholder="请选择状态"
                style="width:200px"
              >
                <el-option label="请选择状态" value="" />
                <el-option
                  v-for="(item,index) in productManageInfo.states"
                  :key="index"
                  :label="item.name"
                  :value="item.statusCd"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="productManageInfo.conditions.shId"
                placeholder="请选择仓库"
                style="width:200px"
              >
                <el-option label="请选择仓库" value="" />
                <el-option
                  v-for="(item,index) in productManageInfo.shopHouses"
                  :key="index"
                  :label="item.shName"
                  :value="item.shId"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="productManageInfo.conditions.hktId"
                placeholder="请选择手机菜单"
                style="width:200px"
              >
                <el-option label="请选择手机菜单" value="" />
                <el-option
                  v-for="(item,index) in productManageInfo.housekeepingTypes"
                  :key="index"
                  :label="item.hktName"
                  :value="item.hktId"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryProductMethod()" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="_resetProductMethod()" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card style="margin-top: 20px;">
          <div slot="header" class="clearfix flex justify-between">
            <span>商品信息</span>
            <div>
              <el-button type="info" @click="_batchEnableSyncAutoShelf()">开启自动上下架</el-button>
              <el-button type="warning" @click="_openBatchUpdateProductState()">批量上/下架</el-button>
              <el-button type="primary" @click="_openAddProductModal()" icon="el-icon-plus">添加商品</el-button>
              <el-button type="primary" @click="_exportProduct()">导出</el-button>
            </div>
          </div>
          <el-table
            :data="productManageInfo.products"
            style="width: 100%"
            border
            stripe
            v-loading="loading"
          >
            <el-table-column prop="productId" label="商品ID" align="center" />
            <el-table-column label="商品图片" align="center">
              <template #default="{row}">
                <el-image
                  style="width: 50px; height: 50px; border-radius: 10px;"
                  :src="row.coverPhoto"
                  :preview-src-list="[row.coverPhoto]"
                >
                  <div slot="error" class="image-slot">
                    <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px; border-radius: 10px;">
                  </div>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" label="商品分组" align="center" />
            <el-table-column prop="prodName" label="商品名称" align="center" />
            <el-table-column prop="shName" label="仓库" align="center" />
            <el-table-column prop="sales" label="销量" align="center" />
            <el-table-column prop="stock" label="库存" align="center" />
            <el-table-column prop="defaultSpecValue.price" label="价格" align="center" />
            <el-table-column prop="sort" label="排序" align="center" />
            <el-table-column prop="stateName" label="状态" align="center" />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column label="操作" align="center" width="360">
              <template #default="{row}">
                <el-button-group>
                  <el-button
                    size="mini"
                    :type="row.state === '2002' ? 'warning' : 'success'"
                    @click="_toggleProductState(row)"
                  >
                    {{ row.state === '2002' ? '下架' : '上架' }}
                  </el-button>
                  <el-button size="mini" @click="_viewProductQrcode(row)">查看</el-button>
                  <el-button size="mini" @click="_openEditProductModel(row)">修改</el-button>
                  <el-button size="mini" @click="_openDeleteProductModel(row)">删除</el-button>
                  <el-button size="mini" @click="_openProductLabelModel(row)">打标</el-button>
                  <el-button size="mini" @click="_openProductDetail(row)">详情</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="productManageInfo.conditions.page"
            :page-size="productManageInfo.conditions.row"
            layout="total, prev, pager, next"
            :total="productManageInfo.total"
            style="margin-top: 20px; text-align: right;"
          />
        </el-card>
      </el-col>
    </el-row>

    <delete-product ref="deleteProduct" @refresh="_listProducts"></delete-product>
    <toggle-product-state ref="toggleProductState" @refresh="_listProducts"></toggle-product-state>
    <batch-update-product-state ref="batchUpdateProductState" @refresh="_listProducts"></batch-update-product-state>
    <choose-product-spec ref="chooseProductSpec" @refresh="_listProducts"></choose-product-spec>
    <add-product-label ref="addProductLabel"></add-product-label>
    <view-qrcode ref="viewQrcode" @refresh="_listProducts"></view-qrcode>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryProduct, queryProductCategory, queryShopHouse, queryHousekeepingType, exportData, batchEnableSyncAutoShelf } from '@/api/goods/productApi'
import DeleteProduct from '@/components/goods/deleteProduct/deleteProduct'
import ToggleProductState from '@/components/goods/toggleProductState/toggleProductState'
import BatchUpdateProductState from '@/components/goods/batchUpdateProductState/batchUpdateProductState'
import ChooseProductSpec from '@/components/goods/chooseProductSpec/chooseProductSpec'
import AddProductLabel from '@/components/goods/addProductLabel/addProductLabel'
import viewQrcode from '@/components/system/viewQrcode'

export default {
  name: 'ProductManage',
  components: {
    DeleteProduct,
    ToggleProductState,
    BatchUpdateProductState,
    ChooseProductSpec,
    AddProductLabel,
    viewQrcode
  },
  data() {
    return {
      loading: false,
      productManageInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        states: [],
        conditions: {
          categoryId: '',
          state: '',
          prodName: '',
          keyword: '',
          barCode: '',
          shopId: '',
          shId: '',
          hktId: '',
          page: 1,
          row: 10
        },
        productCategorys: [],
        shopHouses: [],
        housekeepingTypes: []
      },
      categoryTree: [],
      expandedCategoryIds: {}
    }
  },
  created() {
    this._initData()
  },
  methods: {
    async _initData() {
      let shopId = await getShopId();
      this.productManageInfo.conditions.shopId = shopId
      await this._listProducts()
      await this._listHousekeepingTypes()
      await this._listProductCategorys()
      await this._listShopHouses()
      this._getDictData()
    },
    async _getDictData() {
      try {
        const {data} = await getDict('product', 'state')
        this.productManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listProducts() {
      this.loading = true
      try {
        const params = { ...this.productManageInfo.conditions }
        params.prodName = params.prodName.trim()
        const res = await queryProduct(params)
        this.productManageInfo.total = res.total
        this.productManageInfo.records = res.records
        this.productManageInfo.products = res.data
      } catch (error) {
        console.error('获取商品列表失败:', error)
      } finally {
        this.loading = false
      }
    },
    async _listProductCategorys() {
      try {
        const params = {
          page: 1,
          row: 5000,
          shopId: this.productManageInfo.conditions.shopId,
          queryType: 'lever'
        }
        const res = await queryProductCategory(params)
        const categories = res.data || []
        this.productManageInfo.productCategorys = categories
        this.categoryTree = this._buildCategoryTree(categories)
        this._initExpandedCategories()
      } catch (error) {
        console.error('获取商品分类失败:', error)
      }
    },
    _buildCategoryTree(categories) {
      const isRootCategory = (item) => {
        const level = String(item.categoryLevel || '')
        const parentId = item.parentCategoryId
        return level === '1' || parentId === '-1' || parentId === '' || parentId == null
      }
      const roots = categories.filter(isRootCategory)
      const childCategories = categories.filter(item => !isRootCategory(item))
      const rootIds = new Set(roots.map(root => root.categoryId))
      const tree = roots.map(root => ({
        ...root,
        children: childCategories.filter(child => child.parentCategoryId === root.categoryId)
      }))
      childCategories
        .filter(child => !rootIds.has(child.parentCategoryId))
        .forEach(orphan => {
          tree.push({ ...orphan, children: [] })
        })
      return tree
    },
    _openAddProductModal() {
      this.$router.push('/pages/goods/addProduct')
    },
    async _batchEnableSyncAutoShelf() {
      try {
        await this.$confirm(
          '确认将本店铺全部商品的「同步时商品自动上下架」设为开启吗？开启后第三方同步库存时将根据库存自动修改上下架状态。',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
        const res = await batchEnableSyncAutoShelf({
          shopId: this.productManageInfo.conditions.shopId
        })
        if (res.code === 0) {
          this.$message.success(res.msg || '开启自动上下架成功')
        } else {
          this.$message.error(res.msg || '开启自动上下架失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('开启自动上下架失败:', error)
          this.$message.error('开启自动上下架失败')
        }
      }
    },
    _openBatchUpdateProductState() {
      this.$refs.batchUpdateProductState.open({
        shopId: this.productManageInfo.conditions.shopId,
        productCategorys: this.productManageInfo.productCategorys
      })
    },
    _openEditProductModel(product) {
      this.$router.push(`/pages/goods/editProduct?productId=${product.productId}`)
    },
    _openDeleteProductModel(product) {
      this.$refs.deleteProduct.open(product)
    },
    _openProductDetail(product) {
      window.open(`/#/pages/goods/productDetail?productId=${product.productId}`)
    },
    _queryProductMethod() {
      this.productManageInfo.conditions.page = 1
      this._listProducts()
    },
    _resetProductMethod() {
      this.productManageInfo.conditions.prodName = ''
      this.productManageInfo.conditions.categoryId = ''
      this.productManageInfo.conditions.state = ''
      this._listProducts()
    },
    async _listShopHouses() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.productManageInfo.conditions.shopId
        }
        const res = await queryShopHouse(params)
        this.productManageInfo.shopHouses = res.data
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },
    async _listHousekeepingTypes() {
      try {
        const params = {
          page: 1,
          row: 30,
          typeCd: '2002',
          shopId: '9999',
          skipType: '3'
        }
        const res = await queryHousekeepingType(params)
        this.productManageInfo.housekeepingTypes = res.data
      } catch (error) {
        console.error('获取手机菜单失败:', error)
      }
    },
    _openProductLabelModel(product) {
      this.$refs.addProductLabel.open(product)
    },
    _viewProductQrcode(product) {
      this.$refs.viewQrcode.open({
        qrcodeName: product.prodName,
        qrCodeUrl: product.pageUrl,
        remark: `手机扫码查看商品${product.pageUrl}`
      })
    },
    _toggleProductState(product) {
      this.$refs.toggleProductState.open(product)
    },
    swatchCategory(catalog) {
      this.productManageInfo.conditions.categoryId = catalog.categoryId
      if (catalog.parentCategoryId && catalog.parentCategoryId !== '-1') {
        this.$set(this.expandedCategoryIds, catalog.parentCategoryId, true)
        this._saveExpandedCategoriesToStorage()
      }
      this._listProducts()
    },
    _getCategoryExpandStorageKey() {
      const shopId = this.productManageInfo.conditions.shopId || ''
      return `productManage_categoryExpanded_${shopId}`
    },
    _initExpandedCategories() {
      const expanded = {}
      this.categoryTree.forEach(parent => {
        if (parent.children && parent.children.length) {
          expanded[parent.categoryId] = true
        }
      })
      try {
        const saved = localStorage.getItem(this._getCategoryExpandStorageKey())
        if (saved) {
          const parsed = JSON.parse(saved)
          Object.keys(expanded).forEach(categoryId => {
            if (Object.prototype.hasOwnProperty.call(parsed, categoryId)) {
              expanded[categoryId] = parsed[categoryId]
            }
          })
        }
      } catch (error) {
        console.warn('读取分类折叠状态失败:', error)
      }
      this.expandedCategoryIds = expanded
    },
    _saveExpandedCategoriesToStorage() {
      try {
        if (!this.productManageInfo.conditions.shopId) {
          return
        }
        localStorage.setItem(this._getCategoryExpandStorageKey(), JSON.stringify(this.expandedCategoryIds))
      } catch (error) {
        console.warn('保存分类折叠状态失败:', error)
      }
    },
    isCategoryExpanded(categoryId) {
      return this.expandedCategoryIds[categoryId] !== false
    },
    toggleCategoryExpand(categoryId) {
      this.$set(this.expandedCategoryIds, categoryId, !this.isCategoryExpanded(categoryId))
      this._saveExpandedCategoriesToStorage()
    },
    expandAllCategories() {
      this.categoryTree.forEach(parent => {
        if (parent.children && parent.children.length) {
          this.$set(this.expandedCategoryIds, parent.categoryId, true)
        }
      })
      this._saveExpandedCategoriesToStorage()
    },
    collapseAllCategories() {
      this.categoryTree.forEach(parent => {
        if (parent.children && parent.children.length) {
          this.$set(this.expandedCategoryIds, parent.categoryId, false)
        }
      })
      this._saveExpandedCategoriesToStorage()
    },
    async _exportProduct() {
      try {
        this.productManageInfo.conditions.pagePath = 'storeProductManage'
        const res = await exportData(this.productManageInfo.conditions)
        this.$message.success(res.msg)
        if (res.code === 0) {
          this.$router.push('/pages/property/downloadTempFile?tab=下载中心&fileType=storeProductManage')
        }
      } catch (error) {
        console.error('导出失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.productManageInfo.conditions.page = val
      this._listProducts()
    }
  }
}
</script>

<style scoped>
.category-tree-actions {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px !important;
  font-size: 12px;
  color: #909399;
  border-bottom: 1px solid #ebeef5;
}

.category-tree-actions span {
  cursor: pointer;
}

.category-tree-actions span:hover {
  color: #409EFF;
}

.category-tree-group {
  padding: 0 !important;
}

.category-tree-group:hover {
  background-color: transparent !important;
}

.category-tree-parent-row {
  display: flex;
  align-items: center;
  transition: all 0.3s;
}

.category-tree-parent-row.selected {
  background-color: #409EFF;
}

.category-tree-parent-row.selected .category-tree-item,
.category-tree-parent-row.selected .category-tree-toggle {
  color: #fff;
}

.category-tree-toggle {
  flex-shrink: 0;
  width: 24px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #909399;
}

.category-tree-toggle-placeholder {
  cursor: default;
}

.category-tree-item {
  flex: 1;
  padding: 10px 10px 10px 0;
  cursor: pointer;
  transition: all 0.3s;
  color: #606060;
  font-size: 14px;
}

.category-tree-parent-row:not(.selected) .category-tree-item:hover,
.category-tree-parent-row:not(.selected) .category-tree-toggle:hover {
  background-color: #f5f7fa;
}

.category-tree-children .category-tree-item.selected {
  background-color: #409EFF;
  color: #fff;
}

.category-tree-children {
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-tree-children .category-tree-item {
  padding: 8px 10px 8px 28px;
  font-size: 13px;
}

.category-tree-children .category-tree-item:hover:not(.selected) {
  background-color: #f5f7fa;
}
</style>